import { Colors } from "@auteco/theme"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(() => ({
    container: {
        padding: '20px',
        marginTop: '20px'
    },
    header: {
        marginBottom: '20px',
        display: 'flex',
        alignItems: 'center',
    },
    assignBtn: {
        background: Colors.DARK_BLUE,
        color: 'white',
        '&:hover': {
            background: Colors.DARK_BLUE,
        }
    },
    groupFilter: {
        width: '300px',
        marginRight: '20px'
    },
    actionBtn: {
        margin: '0 12px 12px 0',
        // background: Colors.DARK_BLUE,
        border: `2px solid ${Colors.DARK_BLUE}`,
        // color: 'white',
        // '&:hover': {
        //     background: Colors.DARK_BLUE
        // }
    }
}))

export default useStyles